<template>
  <swiper-slide>
    <div class="slide-wrapper">
      <div class="slide-container">
        <div class="tag">
          {{ tag }} <a @click="clickTagItem" class="tag-close">X</a>
        </div>
      </div>
    </div>
  </swiper-slide>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  name: 'com-tag-tab-item',
  props: [
    'tag',
  ],
  components: {
    swiper,
    swiperSlide,
  },

  methods: {
    clickTagItem() {
      this.$emit('clickTagItem');
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-tag-tab.scss">

</style>



// WEBPACK FOOTER //
// src/components/CompTagTabItem.vue